var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrrigationSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M130.025 134.423H99.526c0 26.092 21.152 47.244 47.244 47.244h61.784v-26.492h-57.777c-11.46 0-20.752-9.291-20.752-20.752z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M208.554 185.167H146.77c-27.98 0-50.744-22.764-50.744-50.744a3.5 3.5 0 0 1 3.5-3.5h30.5a3.5 3.5 0 0 1 3.5 3.5c0 9.513 7.738 17.252 17.25 17.252h57.778a3.5 3.5 0 0 1 3.5 3.5v26.492a3.5 3.5 0 0 1-3.5 3.5zm-105.389-47.244c1.789 22.491 20.663 40.244 43.605 40.244h58.284v-19.492h-54.277c-12.184 0-22.298-9.032-24-20.752z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M162.011 105.52h-17.317c0 10.035-4.818 15.16-9.98 15.16h-44.56c-5.162 0-9.979-5.125-9.979-15.16H62.858s-5.049 35.873 22.135 35.873h54.884c27.183 0 22.134-35.874 22.134-35.874z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M64.996 91.832a3.5 3.5 0 0 1-3.408-2.718c-.027-.107-.762-3.003-3.421-6.837a3.5 3.5 0 0 1 5.752-3.99c3.48 5.019 4.403 8.863 4.496 9.285a3.5 3.5 0 0 1-3.42 4.26zm-16.28-19.59a3.483 3.483 0 0 1-1.874-.547c-2.278-1.45-4.79-2.776-7.467-3.943a3.5 3.5 0 1 1 2.798-6.416c3.007 1.311 5.842 2.809 8.425 4.452a3.5 3.5 0 0 1-1.882 6.454zM77.918 91.818c-.258 0-.52-.029-.782-.09a3.488 3.488 0 0 1-2.634-4.156c.094-.422 1.017-4.266 4.497-9.284a3.501 3.501 0 0 1 5.751 3.989c-2.696 3.888-3.414 6.81-3.42 6.84a3.519 3.519 0 0 1-3.412 2.7zm16.284-19.576a3.5 3.5 0 0 1-1.882-6.454c2.583-1.643 5.418-3.14 8.425-4.452a3.5 3.5 0 1 1 2.798 6.416c-2.676 1.167-5.189 2.494-7.467 3.943a3.484 3.484 0 0 1-1.874.547zM147.577 91.832a3.501 3.501 0 0 1-3.408-2.717c-.023-.095-.756-2.996-3.42-6.838a3.5 3.5 0 0 1 5.751-3.99c3.48 5.019 4.403 8.863 4.497 9.285a3.5 3.5 0 0 1-3.42 4.26zm-16.28-19.59a3.486 3.486 0 0 1-1.874-.547c-2.278-1.45-4.79-2.776-7.466-3.943a3.5 3.5 0 1 1 2.797-6.416 61.752 61.752 0 0 1 8.426 4.452 3.5 3.5 0 0 1-1.882 6.454zM160.5 95.004c-.258 0-.52-.029-.782-.09a3.488 3.488 0 0 1-2.634-4.156c.094-.422 1.017-4.266 4.496-9.284a3.501 3.501 0 0 1 5.752 3.989c-2.696 3.887-3.414 6.81-3.42 6.84a3.519 3.519 0 0 1-3.412 2.7zm16.283-19.577a3.5 3.5 0 0 1-1.882-6.454 61.714 61.714 0 0 1 8.426-4.452 3.5 3.5 0 0 1 2.798 6.417 54.571 54.571 0 0 0-7.467 3.942 3.487 3.487 0 0 1-1.875.547zM139.876 144.893H84.993c-7.77 0-13.977-2.61-18.45-7.758-9.929-11.423-7.27-31.265-7.15-32.104a3.5 3.5 0 0 1 3.465-3.012h17.317a3.5 3.5 0 0 1 3.5 3.5c0 8.012 3.359 11.661 6.48 11.661h44.56c3.12 0 6.479-3.649 6.479-11.66a3.5 3.5 0 0 1 3.5-3.5h17.317a3.5 3.5 0 0 1 3.466 3.011c.118.84 2.778 20.681-7.15 32.104-4.474 5.148-10.681 7.758-18.45 7.758zM66.07 109.02c-.285 5.406-.09 16.814 5.768 23.538 3.127 3.59 7.43 5.336 13.155 5.336h54.883c5.725 0 10.028-1.745 13.155-5.336 5.858-6.723 6.053-18.13 5.768-23.538h-10.792c-1.15 10.388-7.423 15.161-13.292 15.161h-44.56c-5.87 0-12.143-4.773-13.293-15.161z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M197.577 189.43h10.977v-44.85h-10.977a9.568 9.568 0 0 0-9.568 9.567v25.716a9.568 9.568 0 0 0 9.568 9.568z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M208.554 192.93h-10.977c-7.206 0-13.068-5.862-13.068-13.067v-25.716c0-7.206 5.862-13.068 13.068-13.068h10.977a3.5 3.5 0 0 1 3.5 3.5v44.852a3.5 3.5 0 0 1-3.5 3.5zm-10.977-44.85a6.075 6.075 0 0 0-6.068 6.067v25.716a6.075 6.075 0 0 0 6.068 6.068h7.477v-37.852z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M231.354 212.381h37.292v96.431h-37.292z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M268.646 312.313h-37.292a3.5 3.5 0 0 1-3.5-3.5V212.38a3.5 3.5 0 0 1 3.5-3.5h37.292a3.5 3.5 0 0 1 3.5 3.5v96.432a3.5 3.5 0 0 1-3.5 3.5zm-33.792-7h30.292V215.88h-30.292z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M238.057 107.172h23.887v29.587h-23.887z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M261.943 140.259h-23.886a3.5 3.5 0 0 1-3.5-3.5v-29.587a3.5 3.5 0 0 1 3.5-3.5h23.886a3.5 3.5 0 0 1 3.5 3.5v29.587a3.5 3.5 0 0 1-3.5 3.5zm-20.386-7h16.886v-22.587h-16.886z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff354a",
    d: "M274.77 110.492h-49.54c-5.73 0-10.419-4.688-10.419-10.418v-1.291c0-5.73 4.688-10.418 10.418-10.418h49.542c5.73 0 10.418 4.688 10.418 10.418v1.291c0 5.73-4.688 10.418-10.418 10.418z",
    opacity: 1,
    "data-original": "#ff354a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M250 91.865h-4.224a3.5 3.5 0 1 1 0-7H250a3.5 3.5 0 1 1 0 7z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M274.771 113.992h-49.542c-7.674 0-13.918-6.244-13.918-13.918v-1.29c0-7.675 6.244-13.919 13.918-13.919a3.5 3.5 0 1 1 0 7 6.926 6.926 0 0 0-6.918 6.918v1.291a6.926 6.926 0 0 0 6.918 6.918h49.542a6.926 6.926 0 0 0 6.918-6.918v-1.29a6.926 6.926 0 0 0-6.918-6.919 3.5 3.5 0 1 1 0-7c7.674 0 13.918 6.244 13.918 13.918v1.291c0 7.674-6.244 13.918-13.918 13.918z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ee03f",
    d: "M385.516 264.839c-43.753 45.009 0 71.014 0 71.014s43.753-26.005 0-71.014z",
    opacity: 1,
    "data-original": "#9ee03f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M385.516 339.353a3.5 3.5 0 0 1-1.788-.49c-.743-.442-18.23-11.045-20.838-30.745-1.935-14.614 4.833-29.997 20.116-45.719 1.319-1.355 3.702-1.355 5.02 0 15.283 15.722 22.052 31.105 20.116 45.72-2.608 19.7-20.095 30.302-20.838 30.743-.55.327-1.17.491-1.788.491zm0-69.408c-11.947 13.134-17.223 25.656-15.687 37.254 1.716 12.963 11.573 21.418 15.68 24.423 4.108-3.022 14.018-11.55 15.702-24.485 1.509-11.582-3.769-24.08-15.695-37.192z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ee03f",
    d: "M445.287 307.783c-62.16-8.728-57.31 41.937-57.31 41.937s46.825 19.952 57.31-41.937zM325.745 307.783c62.16-8.728 57.31 41.937 57.31 41.937s-46.825 19.952-57.31-41.937z",
    opacity: 1,
    "data-original": "#9ee03f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M404.54 356.302c-9.867 0-17.437-3.15-17.935-3.362a3.498 3.498 0 0 1-2.111-2.885c-.083-.861-1.853-21.235 12.504-34.973 10.651-10.191 27.06-13.814 48.775-10.764a3.5 3.5 0 0 1 2.964 4.05c-3.662 21.618-12.079 36.164-25.016 43.234-6.533 3.569-13.269 4.7-19.18 4.7zm-13.144-9.082c4.872 1.53 17.598 4.483 29.024-1.791 10.238-5.623 17.208-17.263 20.745-34.63-17.623-1.885-30.826 1.24-39.282 9.298-9.437 8.99-10.472 22.01-10.486 27.123z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M366.492 356.302c-5.912 0-12.647-1.13-19.181-4.7-12.937-7.07-21.354-21.616-25.017-43.234a3.502 3.502 0 0 1 2.964-4.05c21.715-3.052 38.125.572 48.776 10.765 14.358 13.738 12.587 34.11 12.505 34.972a3.497 3.497 0 0 1-2.112 2.885c-.498.212-8.07 3.362-17.935 3.362zm-36.626-45.503c3.545 17.397 10.533 29.05 20.802 34.66 11.473 6.269 24.117 3.309 28.968 1.769-.013-5.101-1.043-18.133-10.487-27.131-8.456-8.057-21.662-11.178-39.283-9.298z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M218.272 195.751h63.455v26.95h-63.455zM208.554 133.714h82.891v62.037h-82.891z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c0d7f7",
    d: "M291.446 157.169c-22.807 11.117-59.084 13.95-82.892 14.52v24.062h82.892z",
    opacity: 1,
    "data-original": "#c0d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M281.728 226.2h-63.456a3.5 3.5 0 0 1-3.5-3.5v-26.949a3.5 3.5 0 0 1 3.5-3.5h63.456a3.5 3.5 0 0 1 3.5 3.5v26.95a3.5 3.5 0 0 1-3.5 3.5zm-59.955-7h56.455v-19.949h-56.455z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M291.446 199.251h-82.892a3.5 3.5 0 0 1-3.5-3.5v-62.037a3.5 3.5 0 0 1 3.5-3.5h82.892a3.5 3.5 0 0 1 3.5 3.5v62.037a3.5 3.5 0 0 1-3.5 3.5zm-79.392-7h75.892v-55.037h-75.892z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ee03f",
    d: "M114.484 264.839c-43.753 45.009 0 71.014 0 71.014s43.753-26.005 0-71.014z",
    opacity: 1,
    "data-original": "#9ee03f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M114.484 339.353a3.5 3.5 0 0 1-1.788-.49c-.743-.442-18.23-11.045-20.839-30.745-1.934-14.614 4.834-29.997 20.117-45.719 1.319-1.355 3.701-1.355 5.02 0 15.283 15.722 22.051 31.105 20.116 45.72-2.608 19.7-20.095 30.302-20.838 30.743-.55.327-1.17.491-1.788.491zm0-69.408c-11.926 13.112-17.204 25.61-15.695 37.192 1.683 12.925 11.579 21.45 15.695 24.48 4.113-3.027 14.012-11.553 15.695-24.48 1.509-11.582-3.769-24.08-15.695-37.192z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ee03f",
    d: "M174.255 307.783c-62.16-8.728-57.31 41.937-57.31 41.937s46.825 19.952 57.31-41.937zM54.713 307.783c62.16-8.728 57.31 41.937 57.31 41.937s-46.825 19.952-57.31-41.937z",
    opacity: 1,
    "data-original": "#9ee03f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M133.508 356.302c-9.867 0-17.437-3.15-17.935-3.362a3.498 3.498 0 0 1-2.112-2.885c-.082-.861-1.853-21.234 12.505-34.972 10.652-10.193 27.062-13.815 48.776-10.765a3.5 3.5 0 0 1 2.964 4.05c-3.663 21.618-12.08 36.164-25.017 43.234-6.533 3.569-13.27 4.7-19.18 4.7zm-13.144-9.082c4.871 1.53 17.596 4.486 29.024-1.791 10.238-5.623 17.208-17.263 20.746-34.63-17.625-1.883-30.827 1.24-39.283 9.298-9.437 8.99-10.472 22.01-10.487 27.123z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M95.46 356.302c-5.913 0-12.647-1.13-19.181-4.7-12.937-7.07-21.354-21.616-25.016-43.234a3.502 3.502 0 0 1 2.964-4.05c21.712-3.051 38.124.572 48.775 10.764 14.357 13.738 12.587 34.111 12.504 34.973a3.497 3.497 0 0 1-2.111 2.885c-.498.212-8.07 3.362-17.935 3.362zm-36.625-45.503c3.537 17.367 10.507 29.007 20.745 34.63 11.424 6.274 24.148 3.323 29.024 1.79-.015-5.106-1.048-18.13-10.487-27.122-8.456-8.057-21.662-11.177-39.283-9.298z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a87c4f",
    d: "M373.39 353.255c-26.204 0-41.634 8.684-50.645 17.979-6.638 6.847-17.962 6.865-24.61.026-9.047-9.304-24.469-18.005-50.508-18.005-25.999 0-41.486 9.065-50.581 18.584-6.527 6.83-17.95 6.814-24.465-.026-9.056-9.51-24.549-18.558-50.717-18.558-62.88 0-62.88 40.186-62.88 40.186v23.231c0 11.109 9.512 20.114 21.246 20.114h334.794c11.734 0 21.247-9.005 21.247-20.114v-23.23s0-40.187-62.881-40.187z",
    opacity: 1,
    "data-original": "#a87c4f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d6a43",
    d: "M80.23 436.785h334.794c11.734 0 21.247-9.005 21.247-20.113v-23.23s-.003-2.408-.923-6.04c-147.338 41.45-315.462 12.296-375.28-.613-1.082 3.972-1.085 6.652-1.085 6.652v23.231c0 11.108 9.513 20.113 21.247 20.113z",
    opacity: 1,
    "data-original": "#9d6a43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ee03f",
    d: "M250 264.839c-43.753 45.009 0 71.014 0 71.014s43.753-26.005 0-71.014z",
    opacity: 1,
    "data-original": "#9ee03f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M250 339.353a3.5 3.5 0 0 1-1.788-.49c-.743-.442-18.23-11.045-20.838-30.745-1.935-14.614 4.833-29.997 20.116-45.719 1.319-1.355 3.701-1.355 5.02 0 15.283 15.722 22.052 31.105 20.116 45.72-2.608 19.7-20.095 30.302-20.838 30.743-.55.327-1.17.491-1.788.491zm0-69.408c-11.926 13.112-17.204 25.61-15.695 37.192 1.683 12.925 11.579 21.45 15.696 24.48 4.112-3.027 14.01-11.553 15.694-24.48 1.509-11.582-3.769-24.08-15.695-37.192z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ee03f",
    d: "M309.77 307.783c-62.16-8.728-57.309 41.937-57.309 41.937s46.825 19.952 57.31-41.937zM190.23 307.783c62.16-8.728 57.309 41.937 57.309 41.937s-46.825 19.952-57.31-41.937z",
    opacity: 1,
    "data-original": "#9ee03f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M269.024 356.302c-9.867 0-17.437-3.15-17.935-3.362a3.498 3.498 0 0 1-2.111-2.885c-.083-.861-1.853-21.234 12.504-34.972 10.651-10.193 27.06-13.815 48.776-10.765a3.5 3.5 0 0 1 2.964 4.05c-3.663 21.618-12.08 36.164-25.017 43.234-6.533 3.569-13.269 4.7-19.18 4.7zm-13.144-9.082c4.872 1.53 17.597 4.486 29.024-1.791 10.238-5.623 17.208-17.263 20.746-34.63-17.625-1.883-30.827 1.24-39.283 9.298-9.437 8.99-10.472 22.01-10.487 27.123z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M230.976 356.302c-5.913 0-12.647-1.13-19.181-4.7-12.937-7.07-21.354-21.616-25.017-43.234a3.502 3.502 0 0 1 2.964-4.05c21.715-3.052 38.125.572 48.776 10.765 14.357 13.738 12.587 34.11 12.504 34.972a3.497 3.497 0 0 1-2.111 2.885c-.498.212-8.07 3.362-17.935 3.362zm-36.626-45.503c3.545 17.397 10.533 29.05 20.801 34.66 11.473 6.269 24.118 3.309 28.97 1.769-.014-5.101-1.044-18.133-10.488-27.131-8.456-8.057-21.663-11.178-39.283-9.298z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M415.024 440.285H80.23c-13.645 0-24.747-10.593-24.747-23.613v-23.23c0-.46.098-11.379 8.604-22.25 7.65-9.78 23.886-21.437 57.778-21.437 22.922 0 40.838 6.61 53.25 19.643 2.45 2.574 5.986 4.051 9.702 4.054h.013c3.707 0 7.237-1.469 9.686-4.031 12.468-13.05 30.337-19.666 53.11-19.666 22.88 0 40.717 6.414 53.017 19.065 2.545 2.618 6.018 4.059 9.779 4.059h.01c3.77-.003 7.251-1.452 9.8-4.082 12.25-12.635 30.135-19.042 53.158-19.042 33.892 0 50.127 11.657 57.777 21.436 8.506 10.873 8.604 21.79 8.604 22.25v23.231c0 13.02-11.102 23.613-24.747 23.613zm-293.16-83.53c-58.367 0-59.367 35.204-59.38 36.702v23.215c0 9.16 7.96 16.613 17.746 16.613h334.794c9.786 0 17.747-7.453 17.747-16.613v-23.23c-.014-1.483-1.013-36.687-59.381-36.687-21.056 0-37.25 5.691-48.132 16.915-3.821 3.942-9.223 6.205-14.82 6.209h-.016c-5.669 0-10.922-2.194-14.797-6.18-10.933-11.243-27.081-16.944-47.998-16.944-20.788 0-36.954 5.888-48.05 17.502-3.763 3.937-9.138 6.195-14.748 6.195h-.018c-5.62-.005-11.001-2.274-14.765-6.226-11.04-11.593-27.25-17.471-48.181-17.471z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M369.975 134.423h30.499c0 26.092-21.152 47.244-47.244 47.244h-61.784v-26.492h57.777c11.46 0 20.752-9.291 20.752-20.752z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M353.23 185.167h-61.784a3.5 3.5 0 0 1-3.5-3.5v-26.492a3.5 3.5 0 0 1 3.5-3.5h57.777c9.513 0 17.252-7.739 17.252-17.252a3.5 3.5 0 0 1 3.5-3.5h30.499a3.5 3.5 0 0 1 3.5 3.5c0 27.98-22.764 50.744-50.744 50.744zm-58.284-7h58.284c22.942 0 41.816-17.753 43.605-40.244h-23.612c-1.701 11.72-11.816 20.752-24 20.752h-54.277v19.492z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M337.989 105.52h17.317c0 10.035 4.818 15.16 9.979 15.16h44.56c5.16 0 9.98-5.125 9.98-15.16h17.317s5.049 35.873-22.135 35.873h-54.884c-27.183 0-22.134-35.874-22.134-35.874z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M435.001 91.818c-.258 0-.52-.029-.783-.09a3.488 3.488 0 0 1-2.634-4.156c.094-.422 1.017-4.266 4.497-9.284a3.501 3.501 0 0 1 5.752 3.989c-2.696 3.888-3.415 6.81-3.421 6.84a3.519 3.519 0 0 1-3.411 2.7zm16.283-19.576a3.5 3.5 0 0 1-1.882-6.454c2.583-1.643 5.418-3.14 8.425-4.452a3.499 3.499 0 1 1 2.798 6.416c-2.676 1.167-5.189 2.494-7.467 3.943a3.484 3.484 0 0 1-1.874.547zM422.078 91.832a3.501 3.501 0 0 1-3.408-2.717c-.023-.095-.756-2.996-3.42-6.838a3.5 3.5 0 0 1 5.751-3.99c3.48 5.019 4.403 8.863 4.497 9.285a3.5 3.5 0 0 1-3.42 4.26zm-16.28-19.59a3.483 3.483 0 0 1-1.874-.547c-2.279-1.45-4.79-2.776-7.467-3.943a3.5 3.5 0 1 1 2.798-6.416c3.007 1.311 5.842 2.809 8.425 4.452a3.5 3.5 0 0 1-1.882 6.454zM352.42 91.818c-.259 0-.521-.029-.783-.09a3.488 3.488 0 0 1-2.634-4.156c.094-.422 1.017-4.266 4.497-9.284a3.5 3.5 0 0 1 5.751 3.989c-2.696 3.888-3.414 6.81-3.421 6.84a3.519 3.519 0 0 1-3.41 2.7zm16.282-19.576a3.5 3.5 0 0 1-1.882-6.454c2.584-1.643 5.418-3.14 8.426-4.452a3.5 3.5 0 1 1 2.798 6.416c-2.677 1.167-5.19 2.494-7.467 3.943a3.487 3.487 0 0 1-1.875.547zM339.496 95.019a3.501 3.501 0 0 1-3.408-2.718c-.024-.098-.757-2.998-3.42-6.838a3.5 3.5 0 1 1 5.752-3.99c3.48 5.019 4.402 8.863 4.496 9.285a3.5 3.5 0 0 1-3.42 4.26zm-16.28-19.592a3.486 3.486 0 0 1-1.874-.547 54.571 54.571 0 0 0-7.466-3.942 3.5 3.5 0 0 1 2.797-6.417 61.725 61.725 0 0 1 8.426 4.452 3.5 3.5 0 0 1-1.882 6.454zM415.007 144.893h-54.884c-7.769 0-13.976-2.61-18.45-7.758-9.928-11.423-7.268-31.265-7.15-32.104a3.5 3.5 0 0 1 3.466-3.012h17.317a3.5 3.5 0 0 1 3.5 3.5c0 8.012 3.359 11.661 6.48 11.661h44.56c3.12 0 6.479-3.649 6.479-11.66a3.5 3.5 0 0 1 3.5-3.5h17.317a3.5 3.5 0 0 1 3.466 3.011c.118.84 2.778 20.681-7.15 32.104-4.474 5.148-10.682 7.758-18.45 7.758zm-73.806-35.874c-.285 5.409-.09 16.814 5.768 23.538 3.127 3.59 7.43 5.336 13.155 5.336h54.883c5.725 0 10.028-1.745 13.155-5.336 5.858-6.723 6.053-18.13 5.768-23.538h-10.792c-1.15 10.388-7.423 15.161-13.292 15.161h-44.56c-5.87 0-12.143-4.773-13.293-15.161z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f3ff",
    d: "M302.423 189.43h-10.977v-44.85h10.977a9.568 9.568 0 0 1 9.568 9.567v25.716a9.568 9.568 0 0 1-9.568 9.568z",
    opacity: 1,
    "data-original": "#e3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M302.423 192.93h-10.977a3.5 3.5 0 0 1-3.5-3.5v-44.85a3.5 3.5 0 0 1 3.5-3.5h10.977c7.206 0 13.068 5.861 13.068 13.067v25.716c0 7.205-5.862 13.068-13.068 13.068zm-7.477-7h7.477a6.075 6.075 0 0 0 6.068-6.067v-25.716a6.075 6.075 0 0 0-6.068-6.068h-7.477z",
    opacity: 1,
    "data-original": "#231f20",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrrigationSystem);
export default __webpack_public_path__ + "static/media/irrigationSystem.5766b8126821537da17749e48e7d01d4.svg";
export { ForwardRef as ReactComponent };